<template>
  <v-container fluid class="section-about-contacts py-12" id="section-about-contacts">
    <v-row class="display-1 font-weight-medium">
      <v-col md="8" offset-md="2">
        <p class="text-center"><v-icon class="blink" color="primary">mdi-color-helper</v-icon>Contacts</p>
        <p class="title pt-10">Get in touch !</p>
        <p class="subtitle-1">

        </p>
        <dl class="subtitle-1 inline">
          <dt><v-icon small>mdi-map-marker</v-icon> Location</dt><dd>Patrowl SAS, 10 Rue de Penthièvre, 75008 Paris, France</dd>
          <br/>
          <dt><v-icon small>mdi-email-outline</v-icon> Support</dt><dd>getsupport@patrowl.io</dd>
          <dt><v-icon small>mdi-email-outline</v-icon> Partners</dt><dd>sales@patrowl.io</dd>
          <dt><v-icon small>mdi-email-outline</v-icon> Sales</dt><dd>sales@patrowl.io</dd>
          <dt><v-icon small>mdi-email-outline</v-icon> Careers</dt><dd>hiring@patrowl.io</dd>
          <dt><v-icon small>mdi-email-outline</v-icon> Privacy</dt><dd>privacy@patrowl.io</dd>
          <dt><v-icon small>mdi-email-outline</v-icon> Security</dt><dd>security@patrowl.io</dd>
        </dl>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SecAboutContacts",
};
</script>

<style>
dl.inline dd {
  display: inline;
  margin: 0;
}
dl.inline dd:after{
  display: block;
  content: '';
}
dl.inline dt{
  display: inline-block;
  min-width: 100px;
  font-weight: 600;
}
</style>
